import styled, {
  css,
  DefaultTheme,
  FlattenInterpolation,
  ThemeProps,
} from 'styled-components';

export type TAppStoreIconsSize = 'default' | 'large';

const SIZE_VARIANTS: Record<
  TAppStoreIconsSize,
  FlattenInterpolation<ThemeProps<DefaultTheme>>
> = {
  default: css`
    img {
      height: 28px;
    }
  `,
  large: css`
    img {
      height: 40px;
    }

    ${({ theme }) => css`
      @media (max-width: ${theme.layout.breakpoints.md}) {
        flex-direction: column;
        align-items: center;

        img {
          height: 56px;
        }
      }
    `}
  `,
};

export const Container = styled.div<{ size: TAppStoreIconsSize }>`
  display: flex;
  gap: ${props => props.theme.layout.spacing(1.5)};

  img {
    width: auto;
    display: block;
  }

  ${({ size }) => SIZE_VARIANTS[size]}
`;
